<template>
  <div id="app">
   <!-- <transition name="fade-transform" mode="out-in"> -->
      <router-view/>
   <!-- </transition> -->

  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "@/styles/transition.scss";
  .table{
      margin-top: 20px;
  }
  #app{
    background: #f3fafb;
  }
  h1 {
        font: {
            size: 22px;
            weight: 700;
        }
        margin-bottom: 20px;
  }
  h3{
        font-size: 18px;
        line-height: 40px;
  }
  .ql-editor{
      height:400px;
  }
  h4{
    font-size: 14px;
  }
  // 首页菜单 >
  .el-submenu__title i{
    color: #fff;
  }
  //菜单选中的背景颜色
  .el-menu-item.is-active {
    background-color: #3462ca !important;
  }

   // 处理input type = number的上下箭头
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"]{
    -moz-appearance: textfield;
  }
  //菜单选中后分组的颜色
  .el-menu .el-menu--inline{
    background-color: red;
  }
  .el-menu{
    border: none;
  }
  // td, th{
  //   border: none!important;;
  // }
</style>



// WEBPACK FOOTER //
// src/App.vue